import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRace, getClass } from '@character-creator/data';
import { CharacterBuilder } from '../components/character-builder';
import { ResumeOrStartFreshDialog } from '../components/ui/ResumeOrStartFreshDialog';
import { useCharacterCreationStore } from '../stores/characterCreationStore';
import { hasCharacterData } from '../utils/draftUtils';

interface CreateLocationState {
  freshStart?: boolean;
  fromLibrary?: boolean;
}

export function CreateCharacterPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { draft, reset } = useCharacterCreationStore();
  const [showResumeDialog, setShowResumeDialog] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const state = location.state as CreateLocationState | null;

    if (state?.fromLibrary || state?.freshStart) {
      // Explicit navigation intent — clear state and show builder
      navigate(location.pathname, { replace: true, state: null });
      setChecked(true);
      return;
    }

    // Ambiguous navigation (direct URL, refresh, back button)
    if (hasCharacterData(draft)) {
      setShowResumeDialog(true);
    } else {
      setChecked(true);
    }
  // Only run on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleResume = () => {
    setShowResumeDialog(false);
    navigate(location.pathname, { replace: true, state: null });
    setChecked(true);
  };

  const handleStartFresh = () => {
    reset();
    setShowResumeDialog(false);
    navigate(location.pathname, { replace: true, state: null });
    setChecked(true);
  };

  // Build summary info for the dialog
  const raceName = draft.raceId ? getRace(draft.raceId)?.name : undefined;
  const className = draft.classId ? getClass(draft.classId)?.name : undefined;

  return (
    <>
      {checked && <CharacterBuilder />}
      <ResumeOrStartFreshDialog
        isOpen={showResumeDialog}
        onResume={handleResume}
        onStartFresh={handleStartFresh}
        characterName={draft.name}
        raceName={raceName}
        className={className}
      />
    </>
  );
}
